import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAccessToken } from "../../commercelayer/scripts/token";
import { ElstrJsonRpcResult } from "./LayerIo";

async function prepareHeaderToken(headers: Headers): Promise<Headers> {
  const token = await getAccessToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  return headers;
}

export function transformResponse(response: ElstrJsonRpcResult<any>) {
  return response?.data ?? null;
}

export const createBaseQuery = (path: string) =>
  fetchBaseQuery({
    baseUrl: `/api${path}`,
    prepareHeaders: prepareHeaderToken,
  });
